module.exports = __webpack_public_path__ + "img/IMG-20200823-WA0044.5d190111.jpg";